import { useState } from "react";
import { TimeToTakePills } from "../types";
import { PARTS_OF_THE_DAY } from "../utils";

const Tab = ({
  label,
  value,
  selected,
  setSelectedValue,
}: {
  label: "בוקר" | "צהריים" | "ערב" | "לילה";
  value: TimeToTakePills;
  selected: TimeToTakePills | "";
  setSelectedValue: (value: TimeToTakePills) => void;
}) => {
  return (
    <div
      onClick={() => setSelectedValue(value)}
      className={`border px-8 py-2 min-w-32 text-center rounded border-[#C64192] shadow-sm hover:scale-105 hover:cursor-pointer ${
        selected === value
          ? "bg-[#C64192] text-white"
          : "border-[#C64192] bg-white"
      }`}>
      <span>{label}</span>
    </div>
  );
};

const DayTimesTab = ({
  onTabChange,
}: {
  onTabChange: (value: TimeToTakePills | "") => void;
}) => {
  const [selectedValue, setSelectedValue] = useState<TimeToTakePills | "">("");

  const handleChange = (value: TimeToTakePills) => {
    onTabChange(value === selectedValue ? "" : value);
    setSelectedValue((prev) => (prev === value ? "" : value));
  };

  return (
    <div className="flex gap-10">
      <Tab
        setSelectedValue={handleChange}
        selected={selectedValue}
        value="morning"
        label={PARTS_OF_THE_DAY["morning"].labelHe}
      />
      <Tab
        setSelectedValue={handleChange}
        selected={selectedValue}
        value="noon"
        label={PARTS_OF_THE_DAY["noon"].labelHe}
      />
      <Tab
        setSelectedValue={handleChange}
        selected={selectedValue}
        value="evening"
        label={PARTS_OF_THE_DAY["evening"].labelHe}
      />
      <Tab
        setSelectedValue={handleChange}
        selected={selectedValue}
        value="night"
        label={PARTS_OF_THE_DAY["night"].labelHe}
      />
    </div>
  );
};

export default DayTimesTab;
